import { render } from "./AttrDiff.vue?vue&type=template&id=31aa1b0c&scoped=true"
import script from "./AttrDiff.vue?vue&type=script&lang=js"
export * from "./AttrDiff.vue?vue&type=script&lang=js"

import "./AttrDiff.vue?vue&type=style&index=0&id=31aa1b0c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31aa1b0c"]])

export default __exports__